"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeismicNavigator = void 0;
/// <reference types='@types/angular' />
var rxjs_1 = require("rxjs");
var SeismicHelper_1 = require("../../helper/SeismicHelper");
var CommonService_decorator_1 = require("../../../core/decorators/CommonService.decorator");
var Browser_service_1 = require("../Browser.service");
var Url_service_1 = require("../../../core/services/Url.service");
var SessionStorage_service_1 = require("../../../core/services/storage/SessionStorage.service");
var angular_utils_1 = require("../../../util/angular/angular-utils");
var WindowMessage_service_1 = require("../WindowMessage.service");
/**
 * Responsible for handling navigation such as route changes in Angular or React
 * Over time, this will be changed to correspond with React routing but the API should remain the same
 */
var SeismicNavigator = /** @class */ (function () {
    function SeismicNavigator(sessionStorageService, browserService, urlService, windowMessageService, seismicHelper) {
        var _this = this;
        this.sessionStorageService = sessionStorageService;
        this.browserService = browserService;
        this.urlService = urlService;
        this.windowMessageService = windowMessageService;
        this.seismicHelper = seismicHelper;
        this.history = [];
        this.navigationFromGoBackToLastRoute = false;
        this.lastPath = '';
        this.hasBackButtonEverBeenUsed = false;
        this.onWindowMessageRequestNavigation = function (message) {
            var _a, _b;
            var _c = message.data, url = _c.url, target = _c.target;
            var locationPathName = window.location.pathname.toLowerCase();
            var isX5 = locationPathName === '/x5/' || locationPathName === '/x5/doccenter.aspx' || locationPathName === '/app';
            var inSalesforce = window.salesforce || window.salesforceClientId;
            var isHubspot = JSON.parse(((_b = (_a = window) === null || _a === void 0 ? void 0 : _a.EmbeddedPage) === null || _b === void 0 ? void 0 : _b.seismicIntegratorContext) || '{}').SystemType === 'HubspotCRM';
            if (!_this.isSameOrigin(url) && (inSalesforce || isHubspot)) {
                window.open(url, '_blank');
                return;
            }
            switch (target) {
                case '_blank':
                    window.open(url, target);
                    return;
                case '_parent':
                case '_top':
                    window.open(url, !isX5 && (inSalesforce || isHubspot) ? '_blank' : target);
                    return;
                case '_self':
                default:
                    window.location.href = url;
                    return;
            }
        };
        try {
            var historyAsStr = sessionStorageService.getItem(SeismicNavigator_1.historySessionStorageKey);
            if (historyAsStr) {
                this.history = JSON.parse(historyAsStr);
                if (!Array.isArray(this.history)) {
                    this.history = [];
                    sessionStorageService.setItem(SeismicNavigator_1.historySessionStorageKey, null);
                }
            }
        }
        catch (ex) {
            console.warn('Non fatal: Failed to retrieve history session storage');
        }
        this.replaceState = this.replaceState.bind(this);
        this.pushState = this.pushState.bind(this);
        this.onUrlLocationChange = this.onUrlLocationChange.bind(this);
        this.onWindowHashChange = this.onWindowHashChange.bind(this);
        this.onUrlChangeSubject = new rxjs_1.Subject();
        this.onUrlChange = this.onUrlChangeSubject.asObservable();
        this.bindEvents();
        this.onUrlLocationChange();
        this.windowMessageService.subscribe('requestNavigation', this.onWindowMessageRequestNavigation);
    }
    SeismicNavigator_1 = SeismicNavigator;
    Object.defineProperty(SeismicNavigator.prototype, "params", {
        get: function () {
            return this.getRouteParams();
        },
        enumerable: false,
        configurable: true
    });
    SeismicNavigator.prototype.topNavigate = function (url, target) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, window.postMessage({
                            seismicMessageId: 'requestNavigation',
                            data: { url: url, target: target },
                        }, location.origin)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    SeismicNavigator.prototype.getHref = function (template, params, options) {
        return angular_utils_1.getHref(template, params, options);
    };
    SeismicNavigator.prototype.updateSearchParam = function (paramName, paramValue) {
        return angular_utils_1.updateSearchParam(paramName, paramValue);
    };
    SeismicNavigator.prototype.getRouteName = function () {
        return angular_utils_1.getRouteName();
    };
    SeismicNavigator.prototype.getRouteNameWithDefaultValue = function () {
        var _a;
        var routeName = (_a = angular_utils_1.getRouteName()) !== null && _a !== void 0 ? _a : '';
        return routeName || 'seismicRoot';
    };
    SeismicNavigator.prototype.getRouteParams = function () {
        return angular_utils_1.getRouteParams();
    };
    SeismicNavigator.prototype.getPreviousStateName = function () {
        return angular_utils_1.getPreviousStateName();
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    SeismicNavigator.prototype.go = function (routeTemplate, queryParams, options) {
        return angular_utils_1.go(routeTemplate, queryParams, options);
    };
    SeismicNavigator.prototype.goToHash = function (hash, query) {
        if (query === void 0) { query = {}; }
        return angular_utils_1.goToHash(hash, query);
    };
    SeismicNavigator.prototype.getSearch = function () {
        return angular_utils_1.getSearch();
    };
    /**
     * Goes back to the last route. Only goes back by path, not by query string
     */
    SeismicNavigator.prototype.goBackToLastRoute = function () {
        if (this.history.length < 2) {
            return false;
        }
        var lastRoute = this.history[this.history.length - 2];
        this.history.length -= 1;
        this.navigationFromGoBackToLastRoute = true;
        angular_utils_1.goToHash(lastRoute.hash, lastRoute.search);
        this.hasBackButtonEverBeenUsed = true;
        return true;
    };
    SeismicNavigator.prototype.bindEvents = function () {
        if (this.history.length > 0) {
            var lastHistory = this.history[this.history.length - 1];
            this.lastPath = lastHistory.path;
        }
        this.windowPushState = window.history.pushState;
        this.windowReplaceState = window.history.replaceState;
        window.history.pushState = this.pushState;
        window.history.replaceState = this.replaceState;
        window.addEventListener('hashchange', this.onWindowHashChange);
    };
    SeismicNavigator.prototype.isRelativePath = function (url) {
        // /xx/yy or xx/yy
        return !url.startsWith('http://') && !url.startsWith('https://');
    };
    SeismicNavigator.prototype.isSameOrigin = function (url) {
        var fixedUrl = (url === null || url === void 0 ? void 0 : url.toLowerCase()) || '';
        if (this.isRelativePath(fixedUrl))
            return true;
        var domain = fixedUrl.replace('http://', '').replace('https://', '').split('/')[0];
        return window.location.hostname === domain;
    };
    SeismicNavigator.prototype.onWindowHashChange = function () {
        // This is a workaround for an issue where when clicking the back button in NewsCenter, NewRelicJS
        // is unintentionally setting the hash back to the default hash
        if (location.hash === '#/' && this.hasBackButtonEverBeenUsed === true) {
            if (this.history.length > 0) {
                var lastRoute = this.history[this.history.length - 1];
                window.location.hash = lastRoute.hash;
            }
        }
        this.onUrlLocationChange();
    };
    SeismicNavigator.prototype.onUrlLocationChange = function () {
        var hash = window.location.hash;
        // Don't record empty hashes as sometimes routing temporarily does an empty one
        if (hash === null || hash === '' || hash === '#/') {
            return;
        }
        var value = hash.substr(1, window.location.hash.length - 1);
        var valSplit = value.split('?');
        var path = valSplit[0];
        var routeInfo = this.getCurrentRouteInfo();
        if (SeismicNavigator_1.decodeEncodeCompare(path, this.lastPath) === false) {
            // Path changed!
            if (this.navigationFromGoBackToLastRoute !== true) {
                this.history.push(routeInfo);
            }
            else {
                this.navigationFromGoBackToLastRoute = false;
            }
        }
        else {
            // Potentially a query string change
            this.history[this.history.length - 1] = routeInfo;
        }
        this.lastPath = decodeURIComponent(path);
        this.sessionStorageService.setItem(SeismicNavigator_1.historySessionStorageKey, JSON.stringify(this.history));
        this.onUrlChangeSubject.next({ next: routeInfo, previous: this.lastRouteInfo });
        this.lastRouteInfo = routeInfo;
    };
    SeismicNavigator.prototype.getCurrentRouteInfo = function () {
        // Remove # from beginning
        var location = window.location.hash.substr(1, window.location.hash.length - 1);
        var queryParamSplit = location.split('?');
        var params;
        try {
            params = this.getRouteParams();
        }
        catch (_a) {
            // On first load, the injector is not ready, so this will error out
        }
        return {
            path: queryParamSplit[0],
            hash: location,
            search: this.urlService.getUrlParametersAsObject(location),
            params: params,
        };
    };
    SeismicNavigator.decodeEncodeCompare = function (str1, str2) {
        return (str1 === str2 ||
            decodeURIComponent(str1) === str2 ||
            str1 === decodeURIComponent(str2) ||
            decodeURIComponent(decodeURIComponent(str1)) === str2 ||
            str1 === decodeURIComponent(decodeURIComponent(str2)));
    };
    SeismicNavigator.prototype.pushState = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var returnVal = (_a = this.windowPushState) === null || _a === void 0 ? void 0 : _a.apply(window.history, args);
        this.onUrlLocationChange();
        return returnVal;
    };
    SeismicNavigator.prototype.replaceState = function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var returnVal = (_a = this.windowReplaceState) === null || _a === void 0 ? void 0 : _a.apply(window.history, args);
        this.onUrlLocationChange();
        return returnVal;
    };
    var SeismicNavigator_1;
    SeismicNavigator.historySessionStorageKey = 'seismic-navigator-session-storage-history';
    SeismicNavigator = SeismicNavigator_1 = __decorate([
        CommonService_decorator_1.CommonService('SeismicNavigator'),
        __metadata("design:paramtypes", [SessionStorage_service_1.SessionStorageService,
            Browser_service_1.BrowserService,
            Url_service_1.UrlService,
            WindowMessage_service_1.WindowMessageService,
            SeismicHelper_1.SeismicHelper])
    ], SeismicNavigator);
    return SeismicNavigator;
}());
exports.SeismicNavigator = SeismicNavigator;
//# sourceMappingURL=SeismicNavigator.js.map